null


// WEBPACK FOOTER //
// /Volumes/brazil-workspaces/Phoenix/PITLambda/commands/DescribeEntityRecognizerCommand.ts